// FIXME - not sure there's value in having this in a separate file?


function getProductTypes(permissions) {
    const products = [];
    let settleOnly = permissions.SETTLE && !permissions.TRADE;

    if (settleOnly || permissions.TRADE) {
        if (settleOnly || permissions.SPOT) {
            if (settleOnly || permissions.FWD) {
                products.push({ text: 'td.panel.label.spotforward', value: 'FWD' });
            } else {
                products.push({ text: 'td.panel.label.spot', value: 'FWD' });
            }
        }
        if (settleOnly || permissions.FWDOPT) {
            products.push({ text: 'td.panel.label.forwardOption', value: 'FWDOPT' });
        }
        if (settleOnly || permissions.SWAP) {
            products.push({ text: 'td.panel.label.swap', value: 'SWAP' });
        }
    }

    if (permissions.SCHEDULED_TRADE) {
        products.push({text: 'td.panel.label.scheduledSpot', value: 'SCHEDULED_SPOT'});
    }

    return products;
}

function getProductDefault() {
    return 'FWD';
}

export default {
    getProductTypes,
    getProductDefault
};